/**
 * Products Bundle functionality
 * Handles adding bundle products to cart
 */

class ProductsBundle {
  constructor() {
    this.cartUrl = window.Shopify.routes
      ? window.Shopify.routes.root + "cart.js"
      : "/cart.js";
    this.cartAddUrl = window.Shopify.routes
      ? window.Shopify.routes.root + "cart/add.js"
      : "/cart/add.js";
    this.cartUpdateUrl = window.Shopify.routes
      ? window.Shopify.routes.root + "cart/update.js"
      : "/cart/update.js";
    this.init();
  }

  init() {
    // Initialize event listeners
    document.addEventListener("click", event => {
      if (
        event.target.matches(".bundle-add-to-cart") ||
        event.target.closest(".bundle-add-to-cart")
      ) {
        event.preventDefault();
        const button = event.target.matches(".bundle-add-to-cart")
          ? event.target
          : event.target.closest(".bundle-add-to-cart");
        this.addBundleToCart(button);
      }
    });
  }

  /**
   * Add bundle products to cart
   * @param {HTMLElement} button - The clicked button
   */
  addBundleToCart(button) {
    // Show loading state
    const loaderElement = button.querySelector(".svg-loader");
    const textElement = button.querySelector("span");

    // Add loading class to button
    button.classList.add("loading");

    if (loaderElement) loaderElement.style.display = "block";
    if (textElement) textElement.style.opacity = "0";

    // Get bundle data from button's data attributes
    const bundleData = JSON.parse(
      button.getAttribute("data-bundle-products") || "[]",
    );
    const bundleProduct = button.getAttribute("data-bundle-product");

    // Prepare items to add to cart
    let items = [];
    let payload = {};


    if (bundleProduct && bundleProduct !== "") {
      // Add the bundle product if specified
      payload = {
        id: parseInt(bundleProduct, 10),
        quantity: 1,
      };
    } else if (bundleData.length > 0) {
      // Otherwise add individual products
      bundleData.forEach(product => {
        items.push({
          id: parseInt(product.id, 10),
          quantity: 1,
        });
      });
      payload = { items: items };
    }

    // Add items to cart
    if (payload.id || (payload.items && payload.items.length > 0)) {
      fetch(this.cartAddUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error("Failed to add products to cart");
          }
          return response.json();
        })
        .then(data => {
          const promoCode = (button.getAttribute("data-promo-code") || "").trim();
          const finish = () => {
            button.classList.remove("loading");
            if (loaderElement) loaderElement.style.display = "none";
            if (textElement) textElement.style.opacity = "1";
            this.openCartDrawer();
            this.pushToDataLayer(bundleProduct ? [bundleProduct] : bundleData);
          };

          if (!promoCode) {
            finish();
            return;
          }

          return this.applyPromoCode(promoCode).then(finish, finish);
        })
        .catch(error => {
          console.error("Error adding products to cart:", error);

          // Reset button state
          button.classList.remove("loading");
          if (loaderElement) loaderElement.style.display = "none";
          if (textElement) textElement.style.opacity = "1";

          // Try to open the cart anyway
          this.openCartDrawer();
        });
    }
  }

  /**
   * Apply a discount code without dropping codes already on the cart.
   * @param {string} code
   * @returns {Promise<void>}
   */
  applyPromoCode(code) {
    return fetch(this.cartUrl, {
      headers: { Accept: "application/json" },
    })
      .then(response => response.json())
      .then(cart => {
        const existing = [];
        if (cart && cart.discount_codes) {
          cart.discount_codes.forEach(discount => {
            if (discount.applicable === true && discount.code) {
              existing.push(discount.code);
            }
          });
        }
        const alreadyApplied = existing.some(
          current => current.toLowerCase() === code.toLowerCase(),
        );
        const codes = alreadyApplied ? existing : existing.concat([code]);

        return fetch(this.cartUpdateUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
          body: "discount=" + encodeURIComponent(codes.join(",")),
        });
      });
  }

  /**
   * Open the cart drawer
   */
  openCartDrawer() {
    if (typeof window.openCartDrawer === "function") {
      window.openCartDrawer();
    } else {
      jQuery("[data-cart-drawer]").trigger("click");
    }
  }

  /**
   * Push product data to dataLayer for analytics
   * @param {Array} products - Array of product data
   */
  pushToDataLayer(products) {
    if (typeof dataLayer !== "undefined") {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "add_to_cart",
        currency: Shopify.currency ? Shopify.currency.active : "EUR",
        ecommerce: {
          items: products.map(product => ({
            item_id: product.id.toString(),
            item_name: product.title || "",
            item_brand: product.vendor || "",
            item_category: product.collection || "",
            item_variant: product.variant_sku || "",
            currency: Shopify.currency ? Shopify.currency.active : "EUR",
            price: product.price || 0,
          })),
        },
      });
    }
  }
}

// Initialize the bundle functionality when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new ProductsBundle();
});
